import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
@Component({
    // tslint:disable-next-line:component-selector
    selector: 'btn-cell-rendererAuditCHecklist',
    template: `
            <button mat-mini-fab color="warn" [disabled]="params.node.data.InUse" pTooltip="Delete" tooltipPosition="top" (click)="onClick($event)">
                <mat-icon>delete</mat-icon>
            </button>
            <button mat-mini-fab color="accent" pTooltip="Activate" tooltipPosition="top" style="background: #74ff9e;" (click)="onClick($event)" *ngIf="params.node.data.Status ==='INACTIVE' ? true : false">
                <mat-icon>person</mat-icon>
            </button>
            <button mat-mini-fab color="warn" pTooltip="DeActivate" tooltipPosition="top" (click)="onClick($event)" *ngIf="params.node.data.Status ==='ACTIVE' ? true : false">
                <mat-icon>person_off</mat-icon>
            </button>
            <button mat-mini-fab color="primary" pTooltip="Add Sections" tooltipPosition="top" *ngIf="params.node.data.NoOfSections === 0" (click)="onClick($event)">
                <mat-icon>add_circle</mat-icon>
            </button>
            <button mat-mini-fab color="accent" pTooltip="Edit" tooltipPosition="top" *ngIf="params.node.data.NoOfSections > 0"  (click)="onClick($event)">
                <mat-icon>edit</mat-icon>
            </button>
            <button mat-mini-fab color="accent" pTooltip="View" tooltipPosition="top" style="background: #3f38c8;"  (click)="onClick($event)">
                <mat-icon>remove_red_eye</mat-icon>
            </button>
            <button mat-mini-fab color="accent" pTooltip="Copy Row" tooltipPosition="top" style="background: #c210ce;" (click)="onClick($event)">
                <mat-icon>file_copy</mat-icon>
            </button>
  `
})
export class BtnRendererAuditChecklist implements ICellRendererAngularComp, OnDestroy {
    params: any;

    refresh(params: any): boolean {
        throw new Error('Method not implemented.');
    }
    agInit(params: any): void {
        this.params = params;
    }
    onClick($event: any): any {

        if (this.params.onClick instanceof Function) {
            const params = {
                event: $event,
                rowData: this.params.node.data
            };
            this.params.onClick(params);
        }
    }
    ngOnDestroy(): any {

    }
}